import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { GITIGNORE_TEMPLATES, buildGitignore } from './utils/gitignoreTemplates'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const GitignoreGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de .gitignore | jarder.dev',
    description:
      'Escolha linguagens e ferramentas e monte um arquivo .gitignore ' +
      'combinado na hora. Grátis, direto no navegador.',
  })

  const [selected, setSelected] = useState(['node', 'react'])

  const toggle = (key) => {
    setSelected((current) =>
      current.includes(key) ? current.filter((k) => k !== key) : [...current, key],
    )
  }

  const output = useMemo(() => (selected.length ? buildGitignore(selected) : ''), [selected])

  const copy = () => {
    navigator.clipboard.writeText(output)
    trackEvent('tool_copy', { tool: 'gitignore_generator' })
  }

  const download = () => {
    const blob = new Blob([output], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = '.gitignore'
    a.click()
    URL.revokeObjectURL(url)
    trackEvent('tool_generate', { tool: 'gitignore_generator', selected: selected.join(',') })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de .gitignore</h1>
      <p className="tool-disclaimer">
        Marque as linguagens e ferramentas do seu projeto pra montar um
        .gitignore combinado.
      </p>

      <div className="tool-row" style={{ marginBottom: 20 }}>
        {Object.entries(GITIGNORE_TEMPLATES).map(([key, tpl]) => (
          <label key={key} style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 140 }}>
            <input
              type="checkbox"
              checked={selected.includes(key)}
              onChange={() => toggle(key)}
            />
            {tpl.label}
          </label>
        ))}
      </div>

      {output && (
        <div className="tool-field">
          <textarea rows="16" readOnly value={output} />
          <div className="tool-result-actions">
            <button type="button" className="tool-button" onClick={download}>
              Baixar .gitignore
            </button>
            <button type="button" className="tool-button tool-button-secondary" onClick={copy}>
              Copiar
            </button>
          </div>
        </div>
      )}

      <div className="tool-info-section">
        <h2>Por que usar um .gitignore</h2>
        <p>
          O arquivo <code>.gitignore</code> diz ao Git quais arquivos e
          pastas ignorar ao versionar o projeto: dependências como{' '}
          <code>node_modules</code>, arquivos de build, variáveis de
          ambiente em <code>.env</code> e configurações locais da IDE.
          Isso evita commits acidentais de arquivos pesados, gerados
          automaticamente ou com segredos, mantendo o repositório limpo.
          Combine os templates que fizerem sentido pra stack do seu
          projeto.
        </p>
      </div>
    </div>
  )
}

export default GitignoreGenerator
